import React, {useEffect, useState} from 'react';
import {createRoot} from 'react-dom/client';
import DrupalAccessTokenApi from "../../../js/csf/DrupalAccessTokenApi";
import {startLoadingSpinner, stopLoadingSpinner} from '../../csf-ufc-pivotal/includes/utils';
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import CsfFournisseurPagination from "../includes/csf-fournisseur-pagination";
import {
  CsfPivotalFournisseurFormateurModal
} from "../csf-fournisseur-gestion-formateurs/csf-fournisseur-gestion-formateurs-modal";
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import {CsfFournisseurListModal} from "../csf-fournisseur-gestion-list/csf-fournisseur-gestion-list-modal";
import {handleClickLinks, buildSearchConditionsContains, getSortingQuery, getQueryParams, clearSearchBtn} from '../includes/utils';
import {CsfPivotalFournisseurDeleteModal} from "../includes/csf-fournisseur-delete-modal";
import PropTypes from "prop-types";
import {CsfPivotalFournisseurAddFormateur} from "./csf-fournisseur-detail-list-add-formateur";

// import style
import './csf-fournisseur-detail-list.scss';
import {CsfPivotalFournisseurDetailListTable} from "./csf-fournisseur-detail-list-table";

export function CsfFournisseurFormateurDetailList({apiUrl, apiEnv, formationListUrl}) {

  const [accessToken, setAccessToken] = useState('');
  const [inputSearchValue, setInputSearchValue] = useState('');
  const [listId, setlistId] = useState('');
  const [allTrainers, setAllTrainers] = useState('');
  const [isSearch, setIsSearch] = useState(false);
  const [startRow, setStartRow] = useState(1);
  const [total, setTotal] = useState(0);
  const [deleteType, setDeleteType] = useState('');
  const [title, setTitle] = useState('');
  const offset = 5;
  const [startListRow, setStartListRow] = useState(1);
  const [listTotal, setListTotal] = useState(0);
  const [trainersOfList, setTrainersOfList] = useState([]);
  const [editTrainer, setEditTrainer] = useState([]);
  const [isError, setIsError] = useState('');

  const [isSearchList, setIsSearchList] = useState(false);
  const [startRowList, setStartRowList] = useState(1);
  const [totalList, setTotalList] = useState(0);
  const [filteredTrainers, setFilteredTrainers] = useState([]);
  const [slicedFilteredTrainers, setSlicedFilteredTrainers] = useState([]);
  /*
  * On components mounts fetch the user access token only once.
  * */
  useEffect(() => {
    startLoadingSpinner();
    const params = getQueryParams(window.location.search);
    if(params && params.list){
      setlistId(params.list);
    }
    fetchAccessToken();
  }, []);

  /*
  * Fetch the list info
  * */
  useEffect(() => {
    if (accessToken && listId !== '') {
      getListInfo();
    }
  }, [accessToken]);

  /*
  * When the accessToken is fetched and state is updates, get the formations lists.
  * */
  useEffect(() => {
    if (accessToken) {
      getTrainersList();
      setIsSearch(false);
    }
  }, [accessToken, startRow, isSearch]);

  useEffect(() => {
    setFilteredTrainers(trainersOfList);
    setSlicedFilteredTrainers(trainersOfList.slice((startRowList - 1), (startRowList + offset) - 1));
    setTotal(trainersOfList.length)
  }, [trainersOfList]);


  /*
* When pagination or search is used, remount the trainers array
* */
  useEffect(() => {
    setSlicedFilteredTrainers(filteredTrainers.slice((startRow - 1), (startRow + offset) - 1));
    setIsSearchList(false);
  }, [isSearchList, startRow]);


  /*
  * Method to call drupal api to get the access token of the session.
  * */
  function fetchAccessToken() {
    const drupalAccessTokenApi = new DrupalAccessTokenApi();
    drupalAccessTokenApi.fetchPostRequest('fournisseur')
      .then(response => {
        if (response?.api_access_token) {
          setAccessToken(response.api_access_token);
        } else {
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to pull the detailled info of a list
  * */
  function getListInfo() {
    const requestData = {
      form: "CSF_EP_UXContactList_Info",
      recordId: listId,
    };

    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary?.List_Name) {
          setTitle(response.payload.data.primary.List_Name);
          setTotalList(response.payload.data.primary.CSF_EP_List_Contact_Bridge__Secondary.length)
          setTrainersOfList(response.payload.data.primary.CSF_EP_List_Contact_Bridge__Secondary);
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to fetch the trainers lists.
  * */
  function getTrainersList() {
    const requestData = buildMainBodyDataResquest();
    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          setAllTrainers(response.payload.data.rows);
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method that handle the value changed on the search bar.
  * */
  function handleSearchChange(event) {
    const value = event.target.value;
    setInputSearchValue(value);
  }

  /*
  * Method that handle the click on the search Btn of the search bar
  * */
  function handleSearchBtn(event) {
    if (event.key === 'Enter' || event.type === "click") {
      let filtered = trainersOfList;
      if (inputSearchValue !== '') {
        filtered = trainersOfList.filter((trainer) =>
          (trainer.First_Name?.toLowerCase() ?? '').includes(inputSearchValue.toLowerCase()) ||
          (trainer.Last_Name?.toLowerCase() ?? '').includes(inputSearchValue.toLowerCase()) ||
          (trainer.GSFT_Status_Id__Rn_Descriptor?.toLowerCase() ?? '').includes(inputSearchValue.toLowerCase()) ||
          (trainer.Courriel?.toLowerCase() ?? '').includes(inputSearchValue.toLowerCase())
        );
      }
      setFilteredTrainers(filtered);
      setTotalList(filtered.length);
      setStartRowList(1);
      setIsSearchList(true);
    }
  }

  /*
  * Method that handle the paginations of the main list
  * */
  function handlePaginationClickList(type, event) {
    event.preventDefault();
    if (type === 'prev') {
      setStartRowList((startRowList - offset));
    } else {
      setStartRowList((startRowList + offset));
    }
    const currentPaginationSpan = event.target.closest('.pagination').querySelector('span');
    if (currentPaginationSpan) {
      currentPaginationSpan.focus();
    }
    setIsSearchList(true);
  }

  /*
  * Method to build the body array for the request
  * */
  function buildMainBodyDataResquest() {
    let requestData = {
      startRow: startRow,
      ParameterValues: [""],
      matchCondition: 1,
      search: 'CSF_EP_UXContacts_REST',
      searchResultsList: 'CSF_EP_UXContact_SRL'
    };

    let searchConditions = buildSearchConditionsContains(inputSearchValue, ["First_Name", "Last_Name", "Status_Combo", "Email"]);
    requestData.sort = getSortingQuery("Last_Name", 'asc');

    if (searchConditions.length > 0) {
      requestData.conditions = searchConditions;
    }

    return requestData;
  }

  /*
  * Method that handle the edit modal button
  * */
  function handleModalClick(contactID) {
    setEditTrainer(contactID);
    setDeleteType('listTrainer');
  }

  /*
  * Method that handle de delete button on the delete modal ( can be either a click to delete a list or to delete a trainer)
  * */
  function handleDeleteModal() {
    if (deleteType !== "") {
      startLoadingSpinner();
      if (deleteType === 'list') {
        handleDeleteList();
      } else {
        handleDeleteTrainer();
      }

      setDeleteType('');
    }
  }

  function handleCancelModal() {
    setDeleteType('');
  }

  /*
  * Method that handle de delete of a list via the api
  * */
  function handleDeleteList() {
    const requestData = {
      form: 'CSF_EP_UXContact_List_REST',
      recordId: listId
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormDeleteEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        stopLoadingSpinner();
        if (response?.success) {
          window.location.href = formationListUrl
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });

  }

  /*
  * Method that reset the delete type variable on delete button click.
  * */
  function handleDeleteListCLick() {
    setDeleteType('list');
  }

  /*
  * Method that reset the edit trainers variable if we want to create a new trainers
  * */
  function handleCreateTrainerCLick() {
    setEditTrainer('');
  }

  /*
  * Method that add a trainer to a list (this function is used when a new trainer is created in a detailed list and we want to add it to the list
  * */
  function handleAddCreateTrainerList($trainerId) {
    const requestData = {
      form: "CSF_EP_AddContactList_REST",
      recordId: listId,
      deltaData: {CSF_EP_List_Contact_Bridge__Secondary: [$trainerId]}
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormPutEndpoint(requestData, "_Espace_Partenaire")
      .then(response => {
        if (response?.success) {
          window.location.reload();
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  /*
  * Method that handle de delete of a trainer via the api.
  * */
  function handleDeleteTrainer() {
    stopLoadingSpinner();
    const requestData = {
      form: "CSF_EP_Contact_List_Delete",
      recordId: editTrainer,
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormDeleteEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        stopLoadingSpinner();
        if (response?.success) {
          $("[data-dismiss=modal]").trigger({type: "click"});
          if (listId !== "") {
            window.location.reload();
          }
        } else {
          setIsError(true);
        }
      })
      .catch(error => {
        setIsError(true);
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method that trigger an empty search when X button is clicked in the search field.
  * */
  function retriggerEmptySearch(){
    setInputSearchValue("");
    setFilteredTrainers(trainersOfList);
    setTotalList(trainersOfList.length);
    setStartRowList(1);
    setIsSearchList(true);
  }

  return (
    <main className="fournisseur fournisseur-detail-list">
      <div className="header-wrapper">
        <div className="space-between-wrapper">
          <h1>{title}</h1>

          <div className="buttons-wrapper">
            <button className="button btn-with-icon btn-outlined btn-larger" type="button" data-toggle="modal"
                    data-target="#createTrainersList">
              <span className="icon-csf-edit"><span className="d-none">&nbsp;</span></span>
              {window.Drupal.t('fournisseur.gestion.listing.detail.rename')}
            </button>

            <button onClick={handleDeleteListCLick} className="button btn-with-icon btn-outlined btn-larger" type="button"
                    data-toggle="modal"
                    data-target="#deleteModal">
              <span className="icon-trash-can"><span className="d-none">&nbsp;</span></span>
              {window.Drupal.t('fournisseur.gestion.listing.detail.delete')}
            </button>
          </div>
        </div>
      </div>

      <div className="primary">
        <h2>{window.Drupal.t('fournisseur.trainers.listing.detail.table.title')}</h2>

        <div className="inner-wrapper">
          <div className="space-between-wrapper">
            <button className="button btn-with-icon" type="button" data-toggle="modal" data-target="#AddFormateur">
              <span className="icon-search-user"><span className="d-none">&nbsp;</span></span>
              {window.Drupal.t('fournisseur.gestion.listing.detail.add.list')}
            </button>

            <button onClick={handleCreateTrainerCLick} className="button btn-with-icon btn-outlined" type="button"
                    data-toggle="modal"
                    data-target="#createEditFormateur">
              <i className="icon icon-csf-plus"><span className="d-none">&nbsp;</span></i>
              {window.Drupal.t('fournisseur.gestion.formateurs.create.label')}
            </button>
          </div>

          <div className="search-container">
            <label htmlFor="detailTableSearch" className="sr-only">{window.Drupal.t('search.label')}</label>
            <input type="search" id="detailTableSearch" value={inputSearchValue} onChange={handleSearchChange} onKeyDown={handleSearchBtn}
                   placeholder={window.Drupal.t('fournisseur.search.placeholder')}/>
            <button className="search-close-icon btn-link" aria-label={window.Drupal.t('fournisseur.search.clear.label')}
              onClick={(e) => {
                clearSearchBtn(e, setInputSearchValue)
                retriggerEmptySearch();
              }}
            >
              <i className="icon icon-remove"></i>
            </button>
            <button className="button btn-outlined search-icon" onClick={handleSearchBtn}
              title={window.Drupal.t('search.label')} aria-label={window.Drupal.t('search.label')}>
              <i className="icon icon-search-2"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <CsfPivotalFournisseurDetailListTable
            trainers={slicedFilteredTrainers}
            handleModalClick={handleModalClick}
          />

          <div className="pagination-wrapper space-between-wrapper smaller-wrapper">
            <CsfFournisseurPagination
              startRow={startRow}
              offset={offset}
              total={totalList}
              setStartRowFunction={setStartRow}
            />

            <button className="button btn-with-icon btn-outlined btn-larger" type="button"
                    onClick={() => handleClickLinks(formationListUrl)}>
              {window.Drupal.t('fournisseur.gestion.listing.detail.back.btn')}
            </button>
          </div>
        </div>
      </div>

      <CsfFournisseurListModal
        accessToken={accessToken}
        apiUrl={apiUrl}
        apiEnv={apiEnv}
        listId={listId}
      />

      <CsfPivotalFournisseurFormateurModal
        accessToken={accessToken}
        apiUrl={apiUrl}
        apiEnv={apiEnv}
        editTrainer={editTrainer}
        handleAddCreateTrainerList={handleAddCreateTrainerList}
        addToList={true}
        listId={listId}
        title={title}
      />

      <CsfPivotalFournisseurDeleteModal
        deleteType={deleteType}
        handleDeleteModal={handleDeleteModal}
        handleCancelModal={handleCancelModal}
      />

      <CsfPivotalFournisseurAddFormateur
        accessToken={accessToken}
        apiUrl={apiUrl}
        apiEnv={apiEnv}
        type="list"
        trainers={allTrainers} // Envoyer tous les trainers
        currentTrainers={trainersOfList} //Envoyer les trainers de la liste courante
        startRow={startListRow}
        total={listTotal}
        offset={offset}
        handlePaginationClick={handlePaginationClickList}
        listId={listId}
      />
    </main>
  );
}

window.addEventListener('DOMContentLoaded', () => {
  const domNode = document.getElementById('CsfFournisseurFormateurDetailList');
  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");
    const formationListUrl = domNode.getAttribute("data-api-formation-list");

    root.render(<CsfFournisseurFormateurDetailList
      apiUrl={apiUrl}
      apiEnv={apiEnv}
      formationListUrl={formationListUrl}
    />);
  }
});

CsfFournisseurFormateurDetailList.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  formationListUrl: PropTypes.string,
};
